<div class="page-sub-title">Practice Setup</div>

<div class="tabs-container">
  <div
    class="tabs-header"
    role="tablist"
    aria-label="Practice tabs"
  >

    <button
      type="button"
      class="tab"
      [class.tab-active]="activeTab === 'templates'"
      role="tab"
      [attr.aria-selected]="activeTab === 'templates'"
      aria-controls="templates-panel"
      (click)="activeTab = 'templates'"
    >
        Templates
    </button>

    <button
      type="button"
      class="tab"
      [class.tab-active]="activeTab === 'drills'"
      role="tab"
      [attr.aria-selected]="activeTab === 'drills'"
      aria-controls="drills-panel"
      (click)="activeTab = 'drills'"
    >
      Drills
    </button>

    <span class="tab-underline" [ngStyle]="getTabUnderlineStyle()"></span>
  </div>

  <div class="tabs-body">
    <div
      id="sessions-panel"
      role="tabpanel"
      [hidden]="activeTab !== 'sessions'"
    >
      <!-- Sessions content here -->
    </div>

    <div
      id="templates-panel"
      role="tabpanel"
      [hidden]="activeTab !== 'templates'"
    >
      <!-- Templates content here -->
       <app-template-list></app-template-list>
    </div>

    <div
      id="drills-panel"
      role="tabpanel"
      [hidden]="activeTab !== 'drills'"
    >
      <!-- Drills content here -->
       <app-drills-list></app-drills-list>
    </div>
  </div>
</div>